// extracted by mini-css-extract-plugin
export var audioPlayer = "_po-0";